import { IconButton, InputAdornment } from '@mui/material';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { FormTextField } from 'shared/_ui/form/form-text-field';
import { MouseEvent, useState } from 'react';
import { FormikContextType } from 'formik';

type PasswordField = {
	formik: FormikContextType<any>;
	label: string;
	name: string;
	placeholder?: string;
	disabled?: boolean;
};

export default function PasswordField(props: PasswordField) {
	const { disabled, formik, label, name, placeholder } = props;

	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	return (
		<FormTextField
			autoComplete="off"
			disabled={disabled}
			spellCheck={false}
			autoCapitalize="off"
			name={name}
			type={showPassword ? 'text' : 'password'}
			formik={formik}
			fullWidth
			label={label}
			labelProps={{ position: 'top' }}
			required
			placeholder={placeholder}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton
							aria-label="toggle password visibility"
							onClick={handleClickShowPassword}
							onMouseDown={handleMouseDownPassword}
							edge="end"
						>
							{showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined color="secondary" />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
}
